module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("From Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "fromDate"
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "toDate"
    }
  }, [_vm._v("To Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "toDate"
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Search",
      "icon": "pi pi-search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchProfitLossAnalysis.apply(null, arguments)
      }
    }
  })], 1)])]), _vm._v(" "), _c('DataTable', {
    ref: "po",
    staticClass: "p-datatable-responsive p-datatable-gridlines",
    attrs: {
      "value": _vm.profitAnalysisList,
      "paginator": true,
      "rowsPerPageOptions": [100, 500, 1000],
      "rows": 100,
      "filters": _vm.filters,
      "data-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('Button', {
          attrs: {
            "icon": "pi pi-external-link",
            "label": "Export"
          },
          on: {
            "click": function($event) {
              return _vm.exportCSV($event)
            }
          }
        })], 1)]
      },
      proxy: true
    }, {
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n                " + _vm._s(sl.index + 1) + "\n              ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Date",
      "headerStyle": "width:8em;",
      "sortable": true,
      "field": "salesDateEnglish",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesDateEnglish']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesDateEnglish', $$v)
            },
            expression: "filters['salesDateEnglish']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Miti",
      "headerStyle": "width:8em;",
      "sortable": true,
      "field": "salesDate",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesDate']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesDate', $$v)
            },
            expression: "filters['salesDate']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Bill No",
      "sortable": true,
      "field": "billNo",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['billNo']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'billNo', $$v)
            },
            expression: "filters['billNo']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Customer",
      "sortable": true,
      "field": "accountName",
      "filterField": "accountName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['accountName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'accountName', $$v)
            },
            expression: "filters['accountName']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Item",
      "sortable": true,
      "field": "itemName",
      "filterField": "itemName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['itemName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'itemName', $$v)
            },
            expression: "filters['itemName']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                Total:\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Code",
      "sortable": true,
      "field": "itemCode",
      "filterField": "itemCode",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['itemCode']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'itemCode', $$v)
            },
            expression: "filters['itemCode']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Sales",
      "sortable": true,
      "field": "salesAmount",
      "filterField": "salesAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesAmount', $$v)
            },
            expression: "filters['salesAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalSales.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Purchase",
      "bodyStyle": "text-align: right",
      "field": "purchaseAmount",
      "filterField": "purchaseAmount",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['purchaseAmount']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'purchaseAmount', $$v)
            },
            expression: "filters['purchaseAmount']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalPurchase.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Profit",
      "bodyStyle": "text-align: right",
      "field": "profit",
      "filterField": "profit",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['profit']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'profit', $$v)
            },
            expression: "filters['profit']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalProfit.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Sales Vat",
      "bodyStyle": "text-align: right",
      "field": "salesVat",
      "filterField": "salesVat",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['salesVat']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'salesVat', $$v)
            },
            expression: "filters['salesVat']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalSalesVat.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Purchase Vat",
      "bodyStyle": "text-align: right",
      "field": "purchaseVat",
      "filterField": "purchaseVat",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['purchaseVat']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'purchaseVat', $$v)
            },
            expression: "filters['purchaseVat']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalPurchaseVat.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Vat Difference",
      "bodyStyle": "text-align: right",
      "field": "vatDifference",
      "filterField": "vatDifference",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['vatDifference']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'vatDifference', $$v)
            },
            expression: "filters['vatDifference']"
          }
        })]
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                " + _vm._s(_vm.totalVatDifference.toFixed(2)) + "\n              ")]
      },
      proxy: true
    }])
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13931edc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/analysisReport/profitAndLossAnalysisAccountAndProduct.vue
// module id = 2049
// module chunks = 0